/**
 * Layout route for `/projects/:key/*`.
 *
 * Exists so the tab bar is rendered once, above whatever screen is showing,
 * rather than pasted into ten page components that would then drift apart.
 */

import { Outlet } from 'react-router';
import { ProjectTabs } from './ProjectTabs';

export function ProjectLayout() {
  return (
    <>
      <ProjectTabs />
      <Outlet />
    </>
  );
}
